function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["active", "altButton", "className", "children", "cta", "expanded", "htmlType", "iconOnly", "iconRight", "innerRef", "isDecorative", "layout", "linkIconSize", "linkOptions", "size", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { cloneElement } from 'react';
import { Icon } from '@els/els-react--icon';
import { createEnum, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var ButtonTypes = createEnum(['primary', 'secondary', 'tertiary', 'info', 'warn', 'confirm', 'link', 'transparent', 'borderless']);
var ButtonSizes = createEnum(['default', 'x-small', 'small', 'large']);
var ButtonLayouts = createEnum(['alt', 'vertical']);
var LinkOptions = createEnum(['emphasized', 'icon', 'image', 'inline', 'navigation', 'on-dark', 'selected', 'vertical', 'padded-1o2']);
var ButtonHtmlTypes = createEnum(['button', 'submit', 'reset']);
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  node = PT.node,
  object = PT.object,
  oneOf = PT.oneOf,
  string = PT.string;
var Button = function Button(_ref) {
  var active = _ref.active,
    altButton = _ref.altButton,
    className = _ref.className,
    children = _ref.children,
    cta = _ref.cta,
    expanded = _ref.expanded,
    htmlType = _ref.htmlType,
    iconOnly = _ref.iconOnly,
    iconRight = _ref.iconRight,
    innerRef = _ref.innerRef,
    isDecorative = _ref.isDecorative,
    layout = _ref.layout,
    linkIconSize = _ref.linkIconSize,
    linkOptions = _ref.linkOptions,
    size = _ref.size,
    type = _ref.type,
    buttonProps = _objectWithoutProperties(_ref, _excluded);
  if (type === ButtonTypes.LINK) {
    var classes2 = classnames("button", "button--link", "u-els-anchorize", "c-els-link", className, {
      "c-els-link--image": linkOptions.includes("image"),
      "c-els-link--inline": linkOptions.includes("inline"),
      "c-els-link--navigation": linkOptions.includes("navigation"),
      "c-els-link--on-dark": linkOptions.includes("on-dark"),
      "c-els-link--selected": linkOptions.includes("selected"),
      // Two ways to set 'vertical' links, as users might reasonably expect either to work
      "c-els-link--vertical": layout === "vertical" || linkOptions.includes("vertical"),
      "c-els-link--with-icon": linkOptions.includes("icon"),
      "c-els-link--with-icon-emphasis": linkOptions.includes("emphasized"),
      "c-els-link--padded-1o2": linkOptions.includes("padded-1o2")
    });
    var childToRender = linkOptions.includes("icon") ? cloneElement(children, {
      className: "c-els-link__icon",
      fromLinkButton: true
    }) : children;
    return /* @__PURE__ */React.createElement("button", _objectSpread(_objectSpread({
      className: classes2,
      type: htmlType,
      "data-testid": "button"
    }, buttonProps), {}, {
      ref: innerRef
    }), childToRender);
  }
  var classes = classnames("button", "c-els-button", className, {
    "button--primary": type === ButtonTypes.PRIMARY,
    "button--secondary c-els-button--secondary": type === ButtonTypes.SECONDARY,
    "button--tertiary c-els-button--tertiary": type === ButtonTypes.TERTIARY,
    "button--info c-els-button--info": type === ButtonTypes.INFO,
    "button--warn c-els-button--warn": type === ButtonTypes.WARN,
    "button--confirm c-els-button--confirm": type === ButtonTypes.CONFIRM,
    "button--transparent c-els-button--transparent": type === ButtonTypes.TRANSPARENT,
    "button--transparent c-els-button--borderless": type === ButtonTypes.BORDERLESS,
    "c-els-button--x-small": size === ButtonSizes.X_SMALL,
    "c-els-button--small": size === ButtonSizes.SMALL,
    "c-els-button--large": size === ButtonSizes.LARGE,
    "c-els-button--expanded": expanded,
    "c-els-button--active": active,
    "c-els-button--cta": cta
  });
  return /* @__PURE__ */React.createElement("button", _objectSpread({
    className: classes,
    type: htmlType,
    "data-testid": "button"
  }, buttonProps), children);
};
Button.displayName = "Button";
Button.propTypes = {
  /** Orange state used by the dropdown/menu */
  active: bool,
  /** Only destructured to avoid an unrecognized prop error on the HTML button element */
  altButton: bool,
  /** What to render in the button (text or markup) */
  children: node.isRequired,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** Rounded button style, for standalone buttons */
  cta: bool,
  /** Button width fills its container */
  expanded: bool,
  /** HTML button element types like submit */
  htmlType: oneOf(ButtonHtmlTypes.getAll()),
  /** Only destructured to avoid an unrecognized prop error on the HTML button element */
  iconOnly: bool,
  /** Only destructured to avoid an unrecognized prop error on the HTML button element */
  iconRight: bool,
  /** id for the component */
  id: string,
  /** Ref to enable focus */
  innerRef: object,
  /** Only destructured to avoid an unrecognized prop error on the HTML button element */
  isDecorative: bool,
  /** Can choose vertical layout for button type=link */
  layout: oneOf(ButtonLayouts.getAll()),
  /** Only destructured from props to avoid an error when spreading props onto <button> element */
  linkIconSize: oneOf(Icon.Sizes.getAll()),
  /** Modifies the display of the link based on its use case */
  linkOptions: arrayOf(oneOf(LinkOptions.getAll())),
  /** Button size */
  size: oneOf(ButtonSizes.getAll()),
  /** Use of button by styleguide */
  type: oneOf(ButtonTypes.getAll()),
  /** Handler to execute when button is used */
  onClick: func.isRequired
};
Button.requiredProps = {
  children: ValidPropTypes.NODE,
  onClick: ValidPropTypes.FUNCTION
};
Button.defaultProps = {
  active: false,
  altButton: false,
  className: "",
  cta: false,
  htmlType: ButtonHtmlTypes.BUTTON,
  expanded: false,
  iconOnly: false,
  iconRight: false,
  id: null,
  innerRef: null,
  isDecorative: false,
  layout: null,
  linkIconSize: null,
  linkOptions: [],
  size: null,
  type: ButtonTypes.PRIMARY
};
Button.Sizes = ButtonSizes;
Button.Types = ButtonTypes;
Button.HtmlTypes = ButtonHtmlTypes;
Button.LinkOptions = LinkOptions;
var RawButton = Button;
var Button$1 = makeErrorBoundComponent(RawButton);
var ButtonWithIcon = function ButtonWithIcon(props) {
  var altButton = props.altButton,
    children = props.children,
    className = props.className,
    _fallback = props.fallback,
    iconOnly = props.iconOnly,
    iconRight = props.iconRight,
    linkIconSize = props.linkIconSize,
    sprite = props.sprite,
    type = props.type,
    layout = props.layout;
  if (altButton) {
    console.warn("altButton is deprecated, use layout instead");
  }
  var buttonClasses = classnames(className, {
    "c-els-button--icon": layout !== ButtonLayouts.VERTICAL,
    "c-els-button--icon-only": iconOnly,
    "c-els-button--icon-right": iconRight,
    "c-els-button--alt": layout === ButtonLayouts.ALT || altButton,
    "c-els-button--vertical": layout === ButtonLayouts.VERTICAL
  });
  var linkClasses = classnames("c-els-link--with-icon", className, {
    "c-els-link--with-icon-right": iconRight
  });
  var textClasses = classnames("c-els-button__text", {
    "c-els-link__text": type === "link",
    "u-els-hide-visually": iconOnly
  });
  var icon = /* @__PURE__ */React.createElement(Icon, {
    className: type === "link" ? "c-els-link__icon" : "",
    isDecorative: true,
    size: type === "link" ? linkIconSize : "s",
    sprite: sprite,
    textAlignment: Icon.TextAlignment.OFFSET,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return _fallback || iconOnly ? children : "";
    })
  });
  var wrappedChildren = /* @__PURE__ */React.createElement("span", {
    className: textClasses
  }, children);
  return /* @__PURE__ */React.createElement(Button$1, _objectSpread(_objectSpread({}, props), {}, {
    className: type === "link" ? linkClasses : buttonClasses
  }), iconRight && wrappedChildren, icon, !iconRight && wrappedChildren);
};
ButtonWithIcon.propTypes = _objectSpread(_objectSpread({}, Button$1.propTypes), {}, {
  altButton: PT.bool,
  fallback: PT.func,
  iconOnly: PT.bool,
  iconRight: PT.bool,
  // Allows sizing of icon when link styling is used
  linkIconSize: PT.oneOf(Icon.Sizes.getAll()),
  sprite: PT.oneOf(Icon.Sprites.getAll())
});
ButtonWithIcon.requiredProps = _objectSpread(_objectSpread({}, Button$1.requiredProps), {}, {
  sprite: ValidPropTypes.STRING
});
ButtonWithIcon.defaultProps = _objectSpread(_objectSpread({}, Button$1.defaultProps), {}, {
  altButton: false,
  fallback: null,
  iconOnly: false,
  iconRight: false,
  linkIconSize: "s"
});
ButtonWithIcon.Sizes = ButtonSizes;
ButtonWithIcon.Types = ButtonTypes;
ButtonWithIcon.HtmlTypes = ButtonHtmlTypes;
ButtonWithIcon.LinkOptions = LinkOptions;
ButtonWithIcon.Layouts = ButtonLayouts;
var RawButtonWithIcon = ButtonWithIcon;
var ButtonWithIcon$1 = makeErrorBoundComponent(RawButtonWithIcon);
export { Button$1 as Button, ButtonWithIcon$1 as ButtonWithIcon, RawButton, RawButtonWithIcon };
